var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewNudgesIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 38,
    viewBox: "0 0 32 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.61229 13.4609C3.60769 10.1443 4.91826 6.96303 7.25302 4.62347C9.58778 2.28391 12.7535 0.979647 16.0474 1.00024C22.8523 1.05118 28.2953 6.74637 28.2953 13.6173V14.8454C28.2953 21.044 29.5833 24.641 30.7177 26.6069C30.9664 27.0345 30.9692 27.5633 30.7251 27.9935C30.4809 28.4237 30.027 28.6897 29.5349 28.691H2.37139C1.87921 28.6897 1.42525 28.4236 1.1811 27.9933C0.936944 27.563 0.939846 27.0341 1.1887 26.6066C2.32371 24.6406 3.61229 21.0437 3.61229 14.8454L3.61229 13.4609Z",
    stroke: "#573A78",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4518 28.691V30.2417C10.4518 33.6674 13.0966 36.4445 16.3592 36.4445C19.6218 36.4445 22.2666 33.6674 22.2666 30.2417V28.691",
    stroke: "#573A78",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewNudgesIcon);
export default __webpack_public_path__ + "static/media/newNudgesIcon.235ae7268049f9e284e829026c3e8bc9.svg";
export { ForwardRef as ReactComponent };